//third-party
import { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useLoaderData, useParams       } from "react-router-dom";
import { CarFront } from "react-bootstrap-icons";

//spotsync connect
import { Api, VehicleData } from "./Data/Api";
import { Button          } from "./Controls/Button";
import { del, push       } from "./Data/Array";
import { AddVehicleModal } from "./Controls/AddVehicleModal";
import { VehicleCard     } from "./Controls/VehicleCard";
import { PageTitle       } from "./Controls/PageTitle";
import { processResult   } from "./Data/Result";
import { Vehicle } from "./Data/ApiTypes";

export function UserVehiclesPage() {
    const vs = useLoaderData() as Vehicle[];
    const [vehicles, setVehicles] = useState<Vehicle[]>( vs );
    const [showAddVehicle, setShowAddVehicle] = useState( false );

    function addVehicle( vehicle: VehicleData ) {
        Api.vehicleAdd( vehicle ).then( res => processResult( res, v => {
            setVehicles( push( vehicles, v as Vehicle ) );
        } ) );
    }

    function deleteVehicle( vehicle: Vehicle ) {
        Api.vehicleDelete( vehicle.vehicleId ).then( res => processResult( res, _ => {
            setVehicles( del( vehicles, vehicle ) );
        } ) );
    }

    return <Container fluid>
        <Row>
            <Col>
                <AddVehicleModal show={showAddVehicle} setShow={setShowAddVehicle} onSubmit={addVehicle} />
                <PageTitle>
                    My Vehicles
                </PageTitle>
                <div className="pb-1">
                    <div className="text-secondary">
                        Use this page to add or remove vehicles from your account.
                    </div>
                </div>
                {vehicles.length === 0 ? (
                    <div className="rounded-3 border bg-white text-center px-4 py-5 my-4 shadow-subtle">
                        <div
                            className="rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                            style={{
                                width: 72,
                                height: 72,
                                backgroundColor: "color-mix(in srgb, var(--color-mid) 12%, white)",
                            }}
                        >
                            <CarFront size={28} style={{ color: "var(--color-mid)" }} />
                        </div>
                        <p className="fw-semibold mb-2">You don&apos;t have any vehicles</p>
                        <p className="text-secondary small mb-4 mx-auto" style={{ maxWidth: 320 }}>
                            Add a vehicle to use it on parking plans and reservations.
                        </p>
                        <Button className="btn-main px-4" onClick={() => setShowAddVehicle(true)}>
                            Add Vehicle
                        </Button>
                    </div>
                ) : (
                    <>
                        {vehicles.map((veh, index) =>
                            <VehicleCard key={index}
                                         vehicle={veh}
                                         deleteVehicle={deleteVehicle}
                                         vehicles={vehicles} />
                        )}
                        <div className="text-end mt-3">
                            <Button className="w-100 btn-main" onClick={() => setShowAddVehicle(true)}>Add Vehicle</Button>
                        </div>
                    </>
                )}
            </Col>
        </Row>
    </Container>;
}